import { Component, Prop, h, Host } from '@stencil/core';
import { parseJsonProp } from '../../../../../utils/helpers/hydration';

/**
 * Cookie consent banner for SignNow.
 *
 * @product signnow
 * @version 1.0.0
 * @category SignNow
 * @contentConfig GDPR cookie consent banner with configurable text
 * @example
 *   <sn-cookie-type-1
 *     values='{"COOKIE_BANNER_DESCRIPTION":"We use cookies to improve security and personalize the user experience. By clicking \"Accept\" you agree to the use of cookies.","COOKIE_BANNER_ACCEPT":"Accept","COOKIE_BANNER_READ_MORE":"Read more","COOKIE_BANNER_READ_LESS":"Read less"}'
 *   ></sn-cookie-type-1>
 */
@Component({
  tag: 'sn-cookie-type-1',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SnCookieType1 {
  @Prop() colorMode: 'signnow' | 'inverted' = 'signnow';

  /**
   * Text constants for the cookie banner (legacy prop name — prefer `values`).
   */
  @Prop({ mutable: true }) constants?: Record<string, string> | string;

  /**
   * Editable text fields for the cookie banner.
   * @dynamic
   * @type {object}
   * @property {string} COOKIE_BANNER_DESCRIPTION - Cookie consent description text (HTML allowed, e.g. links to cookie policy)
   * @property {string} COOKIE_BANNER_ACCEPT - Accept button label
   * @property {string} COOKIE_BANNER_READ_MORE - "Read more" toggle label
   * @property {string} COOKIE_BANNER_READ_LESS - "Read less" toggle label
   * @required COOKIE_BANNER_DESCRIPTION
   */
  @Prop({ mutable: true }) values?: Record<string, string> | string;

  @Prop() delay?: number;
  @Prop() closeLabel?: string;

  componentWillLoad() {
    this.constants = parseJsonProp(this.constants);
    this.values = parseJsonProp(this.values);
  }

  render() {
    // Merge values into constants so both prop names work
    const merged = { ...(this.constants as Record<string, string> | undefined), ...(this.values as Record<string, string> | undefined) };
    return (
      <Host data-color-mode={this.colorMode}>
        <cookie-type-1
          constants={Object.keys(merged).length ? merged : undefined}
          delay={this.delay}
          closeLabel={this.closeLabel}
        ></cookie-type-1>
      </Host>
    );
  }
}
